<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Create form</h3>
    </template>

    <template #default="modalProps">
      <FormForm :submit-action="submitAction" @cancel="modalProps.close" />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import FormForm from '@/components/Forms/Form.vue';

export default {
  components: {
    FormForm,
  },

  props: {
    projectUuid: { type: String, required: true },
  },

  methods: {
    ...mapActions('ui/projectForms', {
      storeForm: 'store',
    }),
    submitAction(formData) {
      const { projectUuid } = this;

      return this.storeForm({ projectUuid, formData })
        .then((response) => {
          this.$refs.modal.doClose();
          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
